import * as kakao from './kakao';

export default {
  kakao,
};
